import { applyLandingBrand } from "@/lib/siteHosts"

export const aboutContent = applyLandingBrand({
  eyebrow: "ABOUT THE RESEARCHERS",
  title: "FractoLabs Research Lab • Systems & Automation Group",
  paragraphs: [
    "FractoLabs Research Lab is an independent data analysis group specializing in real-time response latency, intake infrastructure, and customer acquisition efficiency across home services industries.",
    "This nationwide benchmark was conducted by monitoring {count} active digital advertising campaigns across North America and Australia using automated mystery-shopper simulation servers.",
  ],
  architectLabel: "Lead Data Architect:",
  architectName: "Dr. Aris Thorne",
})
